<template>
  <div class="home">
    <folder-modal
      :isModalVisible="showFolderModal"
      folder="/"
      @select="navToFolder"
      @close="showFolderModal = false" />

    <shell>
      <template v-slot:default>

        <div class="lg:w-full container m-auto">
          <div class="w-full lg:w-1/2 m-auto relative">
            <div class="px-2">
              <div class="m-auto">
                <div v-if="isNumberVerified" class="bg-full-blue text-white py-4 px-2 mb-4 text-sm rounded">
                  <p>Your phone number is verified!</p>
                </div>
                <div class="w-full">

                  <!-- <router-link
                       to="/spells"
                       class="py-1 px-2 mb-6 bg-black rounded no-underline text-white w-full block flex items-center justify-cente">
                       <img class="spell-more" src="/HAND_FULL.png" />

                       <div class="text-white pl-1 font-bold text-base">Spells</div>
                       </router-link> -->

                  <div class="pb-12">
                    <!-- <div class="pb-4 text-lg font-bold">Take a note</div> -->
                    <add-record-form  />
                  </div>

                  <div v-if="member.pref_reaction_group === 'UNACK'" class="mb-6 bg-full-blue text-white px-4 rounded">
                    <div class="flex items-center justify-between flex-wrap">
                      <span class="py-4">Using iOS? Enable Reaction Groups <span class="no-wrap" v-html="parsedSymbol('❤ 👍 👎 ‼️ ❓ 😂')"></span></span>
                      <div class="flex py-4">
                        <div
                          class="mr-2 no-underline text-center text-xs font-bold bg-white text-full-blue p-2 rounded cursor-pointer"
                          @click="updateReactionGroupPref('ENABLED')">Yes</div>
                        <div
                          class="no-underline text-center text-xs font-bold bg-white text-full-blue p-2 rounded cursor-pointer"
                          @click="updateReactionGroupPref('DISABLED')">No</div>
                      </div>
                    </div>
                  </div>

                  <div v-else-if="member.pref_reaction_group === 'ENABLED'" class="pb-6">
                    <reaction-groups />
                  </div>


                  <!-- <div v-if="recentPaths && recentPaths.length > 0">
                       <div>
                       <div class="pb-4 text-lg font-bold">Recent Folders

                       <span
                       @click="showFolderModal=true"
                       class="cursor-pointer text-xs text-full-blue underline text-right font-normal ml-2">
                       View All
                       </span>
                       </div>
                       </div>
                       <div v-if="recentPaths && recentPaths.length" class="flex flex-wrap">
                       <div v-for="p in recentPaths"
                       @click="navToFolder(p.path)"
                       class="folder text-sm font-mono pb-2 pt-3 px-2 bg-light-yellow rounded-sm font-bold flex flex-col justify-between cursor-pointer">
                       <div>{{p.path}}</div>

                       </div>
                       </div>
                       </div> -->
                  <div class="flex items-center justify-between">
                    <div class="flex items-baseline">
                      <div class="pb-2 text-lg font-bold">
                        Recent Records
                        <router-link
                          to="/notes"
                          class="text-xs text-full-blue underline text-right font-normal ml-2">
                          View All Records
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <record-list :records="recentRecords" :path="path" />
                    <router-link
                      to="/notes"
                      class="p-4 mb-6 font-bold text-base no-underline text-full-blue rounded w-full block flex items-center justify-center">
                      View All Records
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container m-auto pt-6">
          <div class="lg:w-1/2 m-auto">
            <div class="px-2">
              <!-- <div class="flex items-baseline pb-2">
                   <div class="pb-2 text-lg font-bold">Spells
                   <router-link to="/spells" v-if="records && records.length > 0"
                   class="text-xs text-full-blue underline text-right font-normal ml-2">
                   View All
                   </router-link>
                   </div>

                   </div>
                   <div class="pb-6">
                   <router-link
                   v-for="s in recentScheduledSpells"
                   :to="'/spells/' + s.id"
                   class="p-2 mb-4 block no-underline text-white rounded bg-black">
                   <div
                   class="flex justify-between align-center py-4">
                   <query-name :fn="s.fn"
                   :frequency="s.mode"
                   :startDate="s.start_from" />

                   </div>
                   </router-link>
                   </div> -->


              <div class="flex items-center justify-center">

                <!-- <router-link
                     v-if="isPaidCustomer"
                     to="/spells/create/text"
                     class="mr-4 p-4 spell-tile no-underline text-reminder">
                     <div class="flex flex-col justify-between h-full">
                     <div>
                     <img src="/REMINDER_300.png" width="auto" />
                     <div class="text-white px-1 py-2 pb-2 font-bold text-base">Text Reminder</div>
                     <t-text lvl="2" class="text-white">Need a nudge? It could make all the difference.</t-text>
                     </div>
                     <div
                     class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
                     </div>
                     </router-link>
                     <router-link
                     v-else
                     to="/spells/create/reminder-email"
                     class="mr-4 p-4 spell-tile no-underline text-reminder">
                     <div class="flex flex-col justify-between h-full">
                     <div>
                     <img src="/EVENTS1_300.png" width="auto" />
                     <div class="text-white pb-2 font-bold text-base">Email Reminder</div>
                     <t-text lvl="2" class="text-white">Another kind of nudge. Don't forget to reply.</t-text>
                     </div>
                     <div
                     class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
                     </div>
                     </router-link>


                     <router-link
                     to="/spells/create/email"
                     class="p-4 mr-4 no-underline spell-tile email-digest self-stretch">
                     <div class="flex flex-col justify-between h-full">
                     <div>
                     <img src="/DIGEST_300.png" width="auto" />
                     <div class="text-white px-1 py-2 pb-2 font-bold text-base">Email Digest</div>

                     <t-text lvl="2" class="text-white">What&rsquo;s the use of writing it down if you never look at it?</t-text>

                     </div>
                     <div
                     class="no-underline text-center text-xs font-bold bg-white text-black mt-4 p-2 rounded cursor-pointer">Add Spell</div>
                     </div>
                     </router-link> -->



                

              </div>
            </div>
          </div>
        </div>
      </template>
    </shell>
  </div>
</template>
<script>
 import {mapState, mapActions, mapGetters} from 'vuex';
 import api from '@/api';
  import eventBus from '@/eventBus';

 import AddRecordForm from '@/components/AddRecordForm';
 import RecordList from '@/components/RecordList';
 import SpellBar from '@/components/SpellBar';
 import QueryName from '@/components/QueryName';
 import NoteSelect from '@/components/NoteSelect';
 import AddRecordModal from '@/components/AddRecordModal';
 import FolderModal from '@/components/FolderModal';
 import ReactionGroups from '@/components/ReactionGroups';
 import Shell from '@/components/Shell';

 export default {
   name: 'landing',
   props: {
     path: {
       type: String,
       default: ''
     },
   },
   data () {
     return {
       showRecordModal: false,
       showFolderModal: false,
       records: []
     }
   },

   components: {RecordList, Shell, SpellBar, AddRecordForm, QueryName, FolderModal, ReactionGroups},

   computed: {
     ...mapGetters(['isPaidCustomer']),
     ...mapState({
       recentPaths: state => state.recentPaths,
       spells: state => state.pigs,
       member: state => state.member,
     }),

     recentRecords () {
       return this.records;
     },

     recentScheduledSpells () {
       if (!this.spells.scheduled) {
         return [];
       }

       return this.spells.scheduled.slice(0, 3);
     },

     recentApiSpells () {
       if (!this.spells.apis) {
         return [];
       }

       return this.spells.apis.slice(0, 3);
     },

     isNumberVerified () {
       return !!this.$route.query.numberverified;
     }
   },

   async created () {
     await this.bootstrap();
     eventBus.$on('record', this.bootstrap);
   },

   destroyed () {
     eventBus.$off('record', this.bootstrap);
   },

   methods: {
     ...mapActions([
       'getRecords',
       'getTags',
       'getPaths',
       'addRecord',
       'updateMemberPrefReactionGroup']),

     async bootstrap () {
       // TODO: this is inefficient, it's only needed after login
       this.getTags();
       this.getPaths();

       const {res, err} = await api.getRecentRecords();

       if (err) {
         console.error(err)
       } else {
         this.records = res
       }
     },

     navToFolder (folder) {
       this.$nav('notes', {
         folder
       });
     },

     parsedSymbol (sym) {
       return twemoji.parse(sym)
     },
     async updateReactionGroupPref (pref) {
       await this.updateMemberPrefReactionGroup({pref});
     }
   },

   watch: {
     $route (to) {
       if (to.name !== 'logout') {
         this.bootstrap();
       }
     }
   }
 }
</script>

<style scoped>
 .folder, .spell-tile {
   /* width: 30%;
      margin-right: 5%; */
   
   
 }

 .folder {
   word-wrap: break-word;
   white-space: pre-wrap;
 }

 .folder:nth-child(3n+3), .spell-tile:nth-child(3n+3) {
   margin-right: 0;
 }


 .spell-tile {
   background: #000;
   color: #fff;
   border-radius: 4px;
   
 }

 .spell-tile.inverted {
   background: #0000ff;
   border-radius: 4px;
 }

 .spell-img {
   height: 120px;
   display: block;
   margin: 20px auto;
 }

 .spell-more {
   width: 40px;
 }


 .count {
   background: rgba(0,0,0,.25);
   padding: 5px;
   min-width: 25px;
   text-align: center;
 }
</style>


